import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, vModelSelect as _vModelSelect, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "chips" }
const _hoisted_3 = { class: "segment" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "filters" }
const _hoisted_6 = ["value"]
const _hoisted_7 = {
  key: 0,
  class: "state"
}
const _hoisted_8 = {
  key: 1,
  class: "state"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "lead-top" }
const _hoisted_11 = { class: "lead-company" }
const _hoisted_12 = { class: "lead-sub" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { class: "lead-bottom" }
const _hoisted_15 = { class: "prio" }
const _hoisted_16 = {
  key: 1,
  class: "owner"
}
const _hoisted_17 = { class: "value" }
const _hoisted_18 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_menu_button = _resolveComponent("ion-menu-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, { translucent: true }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { class: "custom-toolbar" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_menu_button, { color: "light" })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_title, { class: "custom-title" }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("Sales Leads", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _ctx.reload
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.refreshOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _createVNode(_component_ion_button, {
                    color: "light",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/sales-lead-form')))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_icon, {
                        slot: "icon-only",
                        icon: _ctx.addOutline
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        fullscreen: true,
        class: "page-bg"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", {
                class: _normalizeClass(["chip", { active: _ctx.followUp === '' && _ctx.status === 'Open' }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setFilter('', 'Open')))
              }, [
                _createElementVNode("b", null, _toDisplayString(_ctx.summary.open || 0), 1),
                _cache[15] || (_cache[15] = _createElementVNode("span", null, "Open", -1))
              ], 2),
              _createElementVNode("div", {
                class: _normalizeClass(["chip warn", { active: _ctx.followUp === 'overdue' }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setFilter('overdue', 'Open')))
              }, [
                _createElementVNode("b", null, _toDisplayString(_ctx.summary.overdue_follow_ups || 0), 1),
                _cache[16] || (_cache[16] = _createElementVNode("span", null, "Overdue", -1))
              ], 2),
              _createElementVNode("div", {
                class: "chip",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push('/sales-lead-meetings')))
              }, [
                _createElementVNode("b", null, _toDisplayString(_ctx.summary.meetings_today || 0), 1),
                _cache[17] || (_cache[17] = _createElementVNode("span", null, "Meetings today", -1))
              ]),
              (_ctx.summary.pending_transfer_approvals)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "chip alert",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$router.push('/sales-lead-transfers')))
                  }, [
                    _createElementVNode("b", null, _toDisplayString(_ctx.summary.pending_transfer_approvals), 1),
                    _cache[18] || (_cache[18] = _createElementVNode("span", null, "To approve", -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scopes, (s) => {
                return (_openBlock(), _createElementBlock("button", {
                  key: s.key,
                  class: _normalizeClass({ on: _ctx.scope === s.key }),
                  onClick: ($event: any) => (_ctx.setScope(s.key))
                }, _toDisplayString(s.label), 11, _hoisted_4))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.search) = $event)),
                type: "search",
                placeholder: "Search company, contact, phone or LD-code",
                onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)), ["enter"])),
                onSearch: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
              }, null, 544), [
                [_vModelText, _ctx.search]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.status) = $event)),
                onChange: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
              }, [...(_cache[19] || (_cache[19] = [
                _createElementVNode("option", { value: "Open" }, "Open", -1),
                _createElementVNode("option", { value: "Won" }, "Won", -1),
                _createElementVNode("option", { value: "Lost" }, "Lost", -1),
                _createElementVNode("option", { value: "Disqualified" }, "Disqualified", -1),
                _createElementVNode("option", { value: "" }, "All", -1)
              ]))], 544), [
                [_vModelSelect, _ctx.status]
              ]),
              _withDirectives(_createElementVNode("select", {
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stage) = $event)),
                onChange: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.reload && _ctx.reload(...args)))
              }, [
                _cache[20] || (_cache[20] = _createElementVNode("option", { value: "" }, "Any stage", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stageOptions, (st) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: st,
                    value: st
                  }, _toDisplayString(_ctx.label(st)), 9, _hoisted_6))
                }), 128))
              ], 544), [
                [_vModelSelect, _ctx.stage]
              ])
            ]),
            (_ctx.loading && !_ctx.leads.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createVNode(_component_ion_spinner, { name: "crescent" })
                ]))
              : (!_ctx.leads.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _cache[21] || (_cache[21] = _createElementVNode("p", null, "No leads here.", -1)),
                    _createElementVNode("button", {
                      class: "btn-primary",
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$router.push('/sales-lead-form')))
                    }, "+ New lead")
                  ]))
                : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.leads, (lead) => {
              return (_openBlock(), _createElementBlock("div", {
                key: lead.id,
                class: "lead-card",
                onClick: ($event: any) => (_ctx.$router.push('/sales-leads/' + lead.id))
              }, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(lead.company_name), 1),
                    _createElementVNode("div", _hoisted_12, [
                      _createTextVNode(_toDisplayString(lead.lead_code), 1),
                      (lead.product_name)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, " · " + _toDisplayString(lead.product_name), 1))
                        : _createCommentVNode("", true),
                      _createTextVNode(" · " + _toDisplayString(lead.contact_name), 1)
                    ])
                  ]),
                  _createElementVNode("span", {
                    class: "pill",
                    style: _normalizeStyle({ background: _ctx.stageColor(lead.stage) })
                  }, _toDisplayString(_ctx.label(lead.stage)), 5)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("span", _hoisted_15, [
                    _createElementVNode("i", {
                      style: _normalizeStyle({ background: _ctx.priorityColor(lead.priority) })
                    }, null, 4),
                    _createTextVNode(_toDisplayString(lead.priority), 1)
                  ]),
                  (lead.status === 'Open')
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        class: _normalizeClass({ overdue: lead.follow_up_overdue })
                      }, [
                        _createVNode(_component_ion_icon, { icon: _ctx.timeOutline }, null, 8, ["icon"]),
                        _createTextVNode(" " + _toDisplayString(lead.next_follow_up_at ? _ctx.format(lead.next_follow_up_at) : 'No follow-up set'), 1)
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.scope !== 'mine')
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(lead.owner_name), 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.money(lead.expected_value)), 1)
                ])
              ], 8, _hoisted_9))
            }), 128)),
            (_ctx.hasMore)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 2,
                  class: "btn-more",
                  disabled: _ctx.loading,
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
                }, _toDisplayString(_ctx.loading ? 'Loading...' : 'Load more'), 9, _hoisted_18))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}